import { Cell, Column } from "react-table";

export default [
    {
        Header: 'Salon',
        accessor: 'salon.name'
    },
    {
        Header: 'Discount',
        accessor: 'discount',
        Cell: ({ value }: Cell<Resources.ClubPromo>) => `${value}%`
    }
] as Column<Resources.ClubPromo>[]